import styled from 'styled-components'
import PopoverMenu from 'src/components/PopoverMenu'

export const Dropdown = styled(PopoverMenu)`
  min-width: 14.5rem !important;
  top: 100% !important;
`

Dropdown.displayName = 'Dropdown'
